import { object, string } from 'yup'
export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  chatId: string().label('Chat ID').required(),
})

export const url = ({ chatId }) => `/v1/chats/${chatId}`
